import { SvgIcon, SvgIconProps } from '@mui/material';

const HeadsetThinIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.3 9c0-1 .7-1.8 1.7-1.8h1c1.5 0 2.8 1.3 2.8 2.8v3c0 1.5-1.3 2.8-2.8 2.8h-1c-1 0-1.8-.8-1.8-1.8V9Zm1.4 5 .3.3h1c.7 0 1.3-.6 1.3-1.3v-3c0-.7-.6-1.3-1.3-1.3h-1l-.3.3v5ZM4.3 9 4 8.7H3c-.7 0-1.3.6-1.3 1.3v3c0 .7.6 1.3 1.3 1.3h1l.3-.3V9Zm1.5 5c0 1-.8 1.8-1.8 1.8H3A2.7 2.7 0 0 1 .2 13v-3C.3 8.5 1.6 7.2 3 7.2h1c1 0 1.8.8 1.8 1.8v5Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.8 8v-.5a5.7 5.7 0 1 0-11.6 0V8a.8.8 0 0 1-1.5 0v-.5a7.2 7.2 0 1 1 14.6 0V8a.8.8 0 0 1-1.6 0ZM11.1 18c0-.3-.2-.5-.5-.5H9.4a.5.5 0 0 0 0 1h1.2c.3 0 .5-.2.5-.5Zm1.5 0a2 2 0 0 1-2 2H9.4a2 2 0 0 1 0-4h1.2a2 2 0 0 1 2 2Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.3 16v-1a.8.8 0 0 1 1.4 0v1c0 1.5-1.2 2.8-2.7 2.8h-2.1a.8.8 0 0 1 0-1.6H14c.7 0 1.3-.5 1.3-1.2Z"
            />
        </SvgIcon>
    );
};

export default HeadsetThinIcon;
